import { CampaignListRow } from '../components/CampaignDataGrid/columns';
import { campaignListRowFromPayload } from '../components/CampaignDataGrid/rows';
import { TrendsHook } from '../hooks/useTrends';
import { CampaignListEntry } from '../slice/schemas';

type TrendData = {
  trendValue: number | null;
  reportDate: string;
};

export const campaignListRowFromEntry = (
  payload: CampaignListEntry,
  trendsHook: TrendsHook
): CampaignListRow => {
  const campaignIdStr = String(payload.campaignId);
  const campaignTrend = trendsHook.trendsData?.data[campaignIdStr];
  const cpgWeeklyTrend = trendsHook.cpgWeeklyTrendsData?.data[campaignIdStr];
  const cpgPartnerTrendsData =
    trendsHook.cpgPartnerTrendsData?.data[campaignIdStr];

  // Temporary version checks that can be removed when we no longer support LCI 2.x
  const trendData: TrendData[] = (() => {
    if (payload.campaignType === 'cpg') {
      return [];
    }

    if (payload.lciVersion >= 3) {
      return (campaignTrend?.visit ?? []).map(t => ({
        trendValue: t.trendValue,
        reportDate: t.reportDate,
      }));
    }

    return [];
  })();

  const salesTrendData: TrendData[] = (() => {
    if (payload.campaignType === 'cpg' && payload.reportType === 'weekly') {
      return (cpgWeeklyTrend?.sales ?? []).map(t => ({
        trendValue: t.trendValue,
        reportDate: t.reportDate,
      }));
    }

    if (payload.campaignType === 'cpg' && payload.reportType === 'partner') {
      return (cpgPartnerTrendsData?.sales ?? []).map(t => ({
        trendValue: t.trendValue,
        reportDate: t.reportDate,
      }));
    }

    if (payload.lciVersion >= 3) {
      return (campaignTrend?.sales ?? []).map(t => ({
        trendValue: t.trendValue,
        reportDate: t.reportDate,
      }));
    }

    return [];
  })();

  return campaignListRowFromPayload(
    payload,
    trendData,
    salesTrendData,
    trendsHook.isTrendsLoading ||
      trendsHook.isCpgWeeklyTrendsLoading ||
      trendsHook.isCpgPartnerTrendsLoading
  );
};
